module.exports = __webpack_public_path__ + "static/media/lnf.13492334.webp";